export function toNumber(fallback: number): (value: string| number | undefined | null) => number;
export function toNumber(): (value: string| number  | undefined | null) => number | undefined;

export function toNumber(fallback?: number) {
    return (value: string | number| undefined | null) => {
        if (typeof value === 'number') {
            return value;
        }

        if (value === undefined || value === null || isNaN(parseFloat(value))) {
            return fallback;
        }

        return parseFloat(value);
    }
}
